<template>
  <div class="field-container">
    <b-row
      v-for="(condition, conditionIndex) in field.conditions"
      :key="`${field.fieldForm.field}-${conditionIndex}`"
      class="condition-row"
    >
      <b-col md="10">
        <b-form-group>
          <b-input-group>
            <b-row class="w-100">
              <b-col :cols="colSize">
                <b-dropdown
                  :text="convertOperatorToReadable(condition.operator)"
                  class="condition-dropdown dropdown-competition"
                  :disabled="field.fieldForm.allowedOperators.length === 1"
                >
                  <b-dropdown-item
                    v-for="(operator, dropdownItemIndex) in field.fieldForm.allowedOperators"
                    @click="onValueChanged(operator.action, 'operator', conditionIndex)"
                    :key="`${field.fieldForm.field}-${dropdownItemIndex}`"
                    >{{ convertOperatorToReadable(operator.action) }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-col>
              <b-col :cols="colSize">
                <b-form-input
                  class="border inputFieldAlign"
                  :min="field.fieldForm.type.min"
                  :max="field.fieldForm.type.max"
                  :value="condition.value"
                  type="number"
                  @change="onValueChanged($event, 'value', conditionIndex)"
                >
                </b-form-input>
              </b-col>
              <b-col cols="2" v-if="showCurrency">
                <dropdown
                  class="dropdown-competition"
                  :label="condition.currency"
                  :items="['HUF', 'EUR']"
                  @onChanged="onValueChanged($event, 'currency', conditionIndex)"
                  :item="condition.currency"
                >
                </dropdown>
              </b-col>
            </b-row>
          </b-input-group>
        </b-form-group>
        <company-field-errors
          v-if="getError(conditionIndex).length > 0"
          :errors="getError(conditionIndex)"
          :innerKey="`condition-${conditionIndex}-error-`"
        />
      </b-col>
      <b-col md="2"
        ><span class="delete-text" @click="onDeleteClicked(conditionIndex)"> <delete-field :hasPadding="true"/></span>
      </b-col>
    </b-row>
    <b-row
      v-if="field.fieldForm.allowedOperators.length !== field.conditions.length"
      class="add-filter"
      @click="onAddFilterClicked"
      md="12"
    >
      <add-new-field />
    </b-row>
  </div>
</template>
<script>
import { getReadableOperator } from '../../models/operator'
import { COMPETITION_FIELD_TYPE } from '../../models/competitionFieldType'
import { CURRENCY } from '../../../../constants/currency'
import Dropdown from '../../../../components/Dropdown.vue'
import CompanyFieldErrors from './CompanyFieldErrors.vue'
import AddNewField from './AddNewField.vue'
import DeleteField from './DeleteField.vue'
export default {
  name: 'NumberField',
  props: ['field', 'onChanged', 'getFieldFormErrors', 'onDelete'],
  components: { Dropdown, CompanyFieldErrors, AddNewField, DeleteField },
  data: function() {
    return { COMPETITION_FIELD_TYPE }
  },
  computed: {
    colSize: function() {
      if (this.showCurrency) {
        return '5'
      }
      return '6'
    },
    showCurrency: function() {
      return this.field.fieldForm.type.additionalType === COMPETITION_FIELD_TYPE.CURRENCY
    },
    conditions: function() {
      return this.field.conditions
    },
    operators: function() {
      const result = this.field.allowedOperators.map(allowedOperator => ({
        value: allowedOperator.action,
        name: getReadableOperator(allowedOperator.action)
      }))
      return result
    }
  },
  methods: {
    onFieldChanged: function(updatedField, conditionIndex) {
      this.onChanged(updatedField, conditionIndex)
    },
    getError: function(conditionIndex) {
      return this.getFieldFormErrors({ key: this.field.fieldForm.field, index: conditionIndex })
    },
    onValueChanged: function(value, key, index) {
      const updatedField = { ...this.field }
      updatedField.conditions = [...updatedField.conditions]
      updatedField.conditions[index] = { ...updatedField.conditions[index] }
      updatedField.conditions[index][key] = value
      this.onFieldChanged(updatedField, index)
    },
    onAddFilterClicked: function() {
      const updatedField = { ...this.field }
      updatedField.conditions = [...updatedField.conditions]
      updatedField.conditions.push({
        operator: this.field.fieldForm.allowedOperators[0].action,
        value: '',
        currency: CURRENCY.HUF
      })
      this.onFieldChanged(updatedField)
    },
    onDeleteClicked: function(index) {
      const updatedField = { ...this.field }
      updatedField.conditions = [...updatedField.conditions]
      updatedField.conditions.splice(index, 1)
      this.onFieldChanged(updatedField, index)
    },
    convertOperatorToReadable: function(operator) {
      const friendlyNameOfAction = this.field.fieldForm.allowedOperators.filter(op => op.action === operator)[0]
        .friendlyNameOfAction
      if (friendlyNameOfAction !== undefined) {
        return friendlyNameOfAction
      } else {
        return getReadableOperator(operator)
      }
    }
  }
}
</script>
<style></style>
